export default {
  videoWrapper: {
    position: 'relative',
    width: 395,
    height: 306,
  },
};
